const { auth, db, formatDoc, snapshotToArray } = require('../firebase');
import { parseUri } from '../../shared/actions/http';
import store from '../store';
const COLLECTION_NAME = 'sites';

// Firebase queries
export const remote = {
  create(data, isLive = false) {
    const user = auth.currentUser;
    const urlParts = parseUri(data.url);

    let docData = Object.assign({}, data, {
      domain: urlParts.host.replace('www.', ''),
      isLive,
      userIds: [user.uid],
      dtCreated: new Date(),
    });

    return db.collection(COLLECTION_NAME)
      .add(docData)
      .then(docRef => docRef.get())
      .then(doc => addLocalSite(formatDoc(doc)));
  },

  findById(siteId) {
    return db.collection(COLLECTION_NAME)
      .doc(siteId)
      .get()
      .then(formatDoc);
  },

  findAllForUser() {
    const user = auth.currentUser;

    return db.collection(COLLECTION_NAME)
      .where('userIds', 'array-contains', user.uid)
      .get()
      .then(snapshotToArray)
      .then(sites => {
        store.set('local.sites', sites);
        return sites;
      });
  }
};

export function addLocalSite(site) {
  let localSites = store.get('local.sites');
  let hasLocalSite = localSites.find(s => s.id === site.id);

  if (!hasLocalSite) {
    localSites.push(site);
  }

  store.set('local.sites', localSites);

  return site;
}
